<template>
  <div class="main-ct">
    <div class="description-ct">
      <p class="heading-paragraph">
        {{ $t('Gamification_Thunderbite_Games_For_Every_Challenge') }}
      </p>
      <p class="description-paragraph">
        {{ $t('Gamification_Thunderbite_Games_Choose_Games') }}
        <router-link :to="projectRoute({ name: 'GamesHubCatalogue' })">
          <span class="game-catalogue-link">
            {{ $t('Gamification_Thunderbite_Games_See_Catalogue') }}
          </span>
        </router-link>
      </p>
    </div>
    <div>
      <img
        src="@/img/gamification/xp-tb-games.png"
        :alt="$t('Gamification_Thunderbite_Games_For_Every_Challenge')"
      />
    </div>
  </div>
</template>

<script>
import { projectRoute } from '@/core/helpers'

export default {
  name: 'GamificationThunderbiteGames',
  methods: { projectRoute }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 65px;
  gap: 20px;
}

.description-ct {
  width: 740px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.heading-paragraph {
  color: #5c6374;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}

.description-paragraph {
  font-size: 16px;
  color: #7e8596;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
}

img {
  width: 1022px;
  height: 298px;
  object-fit: contain;
}

.game-catalogue-link {
  color: #1d87c9;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationThunderbiteGames.vue